import React from 'react'
import { AlertCircle, XCircle, RefreshCw } from 'lucide-react'
import { cn } from '@/lib/utils'

interface ErrorAlertProps {
  title?: string
  message: string
  variant?: 'error' | 'warning'
  onRetry?: () => void
  className?: string
}

const ErrorAlert: React.FC<ErrorAlertProps> = ({ 
  title, 
  message, 
  variant = 'error',
  onRetry,
  className 
}) => {
  const isError = variant === 'error'
  
  return (
    <div className={cn(
      'border rounded-lg p-4',
      isError 
        ? 'bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800'
        : 'bg-yellow-50 dark:bg-yellow-900/20 border-yellow-200 dark:border-yellow-800',
      className
    )}>
      <div className="flex items-start space-x-3">
        {isError ? (
          <XCircle className="h-5 w-5 text-red-600 dark:text-red-400 mt-0.5 flex-shrink-0" />
        ) : (
          <AlertCircle className="h-5 w-5 text-yellow-600 dark:text-yellow-400 mt-0.5 flex-shrink-0" />
        )}
        <div className="flex-1 min-w-0">
          {title && (
            <h3 className={cn(
              'text-sm font-medium',
              isError 
                ? 'text-red-800 dark:text-red-200'
                : 'text-yellow-800 dark:text-yellow-200'
            )}>
              {title}
            </h3>
          )}
          <p className={cn(
            'text-sm',
            title ? 'mt-1' : '',
            isError 
              ? 'text-red-700 dark:text-red-300'
              : 'text-yellow-700 dark:text-yellow-300'
          )}>
            {message}
          </p>
          {onRetry && (
            <button
              onClick={onRetry}
              className={cn(
                'mt-3 inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-md transition-colors',
                isError
                  ? 'bg-red-600 hover:bg-red-700 text-white'
                  : 'bg-yellow-600 hover:bg-yellow-700 text-white'
              )}
            >
              <RefreshCw className="h-3 w-3 mr-1.5" />
              Retry
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default ErrorAlert
